var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({ref:"select",attrs:{"id":_vm.id,"disabled":_vm.computedDisabled,"error":_vm.computedHasError,"error-messages":_vm.computedErrorMessages,"hide-details":_vm.computedHideDetails,"loading":_vm.computedLoading,"messages":_vm.computedMessages,"items":_vm.internalItems},on:{"input":_vm.updateValue}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }